module.exports = __webpack_public_path__ + "static/media/galaxy.17cca43f.jpg";